/*
  Геро на повний екран мусить домовитись із шапкою теми. Режими два.

  1. Прозора шапка (page-header layout = option_4). Тема очікує, що перша
     секція після шапки сама підтягнеться вгору негативним відступом — так
     кадр іде під шапку, і їй є над чим бути прозорою. Так само робить рідна
     page-header-logo-banner.

  2. Звичайна шапка. Вона займає своє місце в потоці, тож геро на 100svh
     виштовхнув би власні кнопки за екран. Віднімаємо зайняту висоту.

  Скільки саме зайнято — не рахуємо по частинах (шапка + оголошення + що
  завгодно ще), а міряємо позицію самої секції. Так логіка не залежить від
  того, які елементи стоять вище і чи вони взагалі в потоці.
*/
(function () {
  var SEL = '[data-bz-hero]';

  function isTransparentHeader() {
    var header = document.querySelector('.wt-header');
    return !!(
      header &&
      header.dataset.transparent &&
      header.classList.contains('wt-header--v3')
    );
  }

  /* Підтягувати геро під шапку можна лише тоді, коли над ним немає нічого,
     крім самої шапки й смуги оголошень — інакше він накриє сусідній блок.

     Тема для цього вимагала, щоб банер був сусіднім вузлом у групі шапки.
     Нам це не потрібно: перевіряємо не місце в DOM, а фактичну позицію. Так
     геро може жити там, де йому й місце — у шаблоні головної. */
  function chromeBottom() {
    var scrolled = window.scrollY || window.pageYOffset;
    var bottom = 0;

    ['.wt-announcement', '.wt-header'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var pos = window.getComputedStyle(el).position;
      if (pos === 'fixed') return; // не в потоці — місця не займає
      var r = el.getBoundingClientRect();
      bottom = Math.max(bottom, r.bottom + scrolled);
    });

    return Math.round(bottom);
  }

  function sitsAtTop(occupied) {
    return occupied - chromeBottom() <= 4;
  }

  /* Клас прозорості знімають лише скрипти рідних банерів теми
     (page-header-logo-banner, page-header-image-banner). Якщо їх вимкнено,
     шапка лишається прозорою назавжди — і темні іконки їдуть по контенту.
     Тож поки геро у кадрі, шапка прозора; вийшов — суцільна. */
  var watched = new WeakSet();

  function watchTransparency(host) {
    if (watched.has(host) || !('IntersectionObserver' in window)) return;
    watched.add(host);

    var io = new IntersectionObserver(
      function (entries) {
        var header = document.querySelector('.wt-header');
        if (!header) return;
        entries.forEach(function (e) {
          header.classList.toggle('wt-header--transparent', e.isIntersecting);
        });
      },
      { threshold: 0.05 }
    );
    io.observe(host);
  }

  function fit() {
    var scrolled = window.scrollY || window.pageYOffset;
    var transparent = isTransparentHeader();
    var sticky = document.body.classList.contains('page-header-sticky');
    var threshold = document.querySelector('.sticky-header__threshold');

    document.querySelectorAll(SEL).forEach(function (el) {
      var host = el.closest('section') || el;

      // Міряємо з чистого аркуша: попередній відступ спотворив би позицію
      host.style.marginTop = '';
      var occupied = Math.max(0, Math.round(host.getBoundingClientRect().top + scrolled));

      if (transparent && sitsAtTop(occupied)) {
        host.style.marginTop = '-' + occupied + 'px';
        el.style.setProperty('--bz-hero-offset', '0px');
        document.body.classList.add('bz-hero-page');
        // Липка шапка має вмикатися після геро, а не одразу — як у теми
        if (sticky && threshold) threshold.style.height = '110vh';
        watchTransparency(host);
      } else {
        el.style.setProperty('--bz-hero-offset', occupied + 'px');
        if (sticky && threshold) threshold.style.height = '200px';
      }
    });
  }

  function schedule() {
    requestAnimationFrame(fit);
  }

  schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
})();
